require('bootstrap');
require('summernote/dist/summernote.css');
require('summernote/dist/summernote.js');
require('angular-summernote');

/*@ngInject*/
angular.module('gw-um-email-editor', [
    'umCore',
    'summernote'
])
    .value('emailEditorConstant', {
        event: {
            EMAIL_UPDATE_COMPLETE: 'emailEditorModule.EmailUpdateComplete',
            PEOPLE_LIST_LOADED:'emailModule.PeopleListLoaded'
        }
    })
    .run(function () {});

require('./emailEditorComponent.js');


module.exports = 'gw-um-email-editor';
